import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';

interface ScreenDoneProps {
	onClose: () => void;
}

export function ScreenDone({ onClose }: ScreenDoneProps) {
	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation('View.CreateNewMessage.ScreenDone.Title')}
				description={withTranslation('View.CreateNewMessage.ScreenDone.Description')}
				illustration='messageSent'
				callToAction={withTranslation('View.CreateNewMessage.Closed.Button')}
				callToActionCallback={onClose}
			/>
		</>
	);
}
